"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalLink = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const Link_1 = require("../BaseLink/Link");
exports.InternalLink = (0, react_1.forwardRef)((props, ref) => {
    return (0, jsx_runtime_1.jsx)(material_1.Link, { ref: ref, component: Link_1.BaseLink, ...props });
});
exports.InternalLink.displayName = "InternalLink";
//# sourceMappingURL=InternalLink.js.map